import React, { useId } from 'react';
import { View } from 'react-native';
import Svg, { Circle, Defs, Line, Pattern, Rect } from 'react-native-svg';
import { withUnistyles } from 'react-native-unistyles';

import { styles } from './styles';
import type { DayStripesOverlayProps } from './types';

const ThemedLine = withUnistyles(Line);

const VIEWBOX_SIZE = 28;
const PATTERN_TILE = 5;
const STRIPE_STROKE = 1;

const DayStripesOverlay: React.FC<DayStripesOverlayProps> = ({ testID }) => {
  const reactId = useId();
  const patternId = `day-stripes-${reactId}`;

  return (
    <View style={styles.container} pointerEvents="none" testID={testID}>
      <Svg
        width="100%"
        height="100%"
        viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      >
        <Defs>
          <Pattern
            id={patternId}
            patternUnits="userSpaceOnUse"
            width={PATTERN_TILE}
            height={PATTERN_TILE}
            patternTransform="rotate(45)"
          >
            <Rect
              width={PATTERN_TILE}
              height={PATTERN_TILE}
              fill="transparent"
            />
            <ThemedLine
              x1="0"
              y1="0"
              x2="0"
              y2={PATTERN_TILE}
              uniProps={(t) => ({ stroke: t.backgroundL3 })}
              strokeWidth={STRIPE_STROKE}
            />
          </Pattern>
        </Defs>
        <Circle
          cx={VIEWBOX_SIZE / 2}
          cy={VIEWBOX_SIZE / 2}
          r={VIEWBOX_SIZE / 2}
          fill={`url(#${patternId})`}
        />
      </Svg>
    </View>
  );
};

DayStripesOverlay.displayName = 'DayStripesOverlay';

export { DayStripesOverlay };
